import { addHours, format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

/**
 * @description Retorna string com a data formatada.
 * @param {Date} '2022-08-23T11:42:03.440Z'
 * @returns {String} Qua, 23/08/2022
 */
function formataSemanaData(data) {
  return format(parseISO(data), 'EEEEEE, dd/MM/yy', { locale: ptBR });
}

/**
 * @description Retorna string com a data formatada.
 * @param {String} '2022-08-23T11:42:03.440Z'
 * @returns {String | null} 26/07/2022 ás 11:42
 */
function getDataHorasFomatada(date) {
  if (date) {
    return format(new Date(date), "dd/MM/yyyy 'ás' HH:mm", {
      locale: ptBR,
    });
  }

  return null;
}

function getDataHoraFormatada(date) {
  return format(new Date(date), 'yyyy-MM-dd HH:mm:ss', { locale: ptBR });
}

function getDataHorasFomatadaAdd3Hours(date) {
  if (date) {
    return format(addHours(new Date(date), 3), "dd/MM/yyyy 'ás' HH:mm", {
      locale: ptBR,
    });
  }

  return null;
}

export {
  formataSemanaData,
  getDataHoraFormatada,
  getDataHorasFomatada,
  getDataHorasFomatadaAdd3Hours,
};
